const translations = {
  fr: {
    nav: {
      home: "Accueil",
      projects: "Projets",
      contact: "Contact",
    },
    hero: {
      greeting: "Bonjour, je suis",
      name: "Benjamin REPELLIN",
      role: "Développeur Full Stack",
      description:
        "Passionné par le domaine de l'informatique et plus particulièrement du développement.",
      cta_projects: "Voir mes projets",
      cta_contact: "Me contacter",
    },
    about: {
      title: "À propos de moi",
      text1:
        "Je suis actuellement étudiant en école d'ingénieur au CESI de Montpellier dans le domaine de l'informatique, et alternant au sein de Atos en tant que développeur d'applications.",
      text2:
        "Passionné par les nouvelles technologies, j'explore constamment de nouveaux outils pour rester à jour sur les tendances du développement moderne.",
      stat1_value: "1 an et demi",
      stat1_label: "D'expérience en entreprise",
      stat2_value: "10+",
      stat2_label: "De projets réalisés",
      stat3_value: "6+",
      stat3_label: "Technologies maîtrisées",
    },
    skills: {
      title: "Compétences",
      subtitle: "Technologies & outils que je maîtrise",
      level_expert: "Expert",
      level_advanced: "Avancé",
      level_intermediate: "Intermédiaire",
      level_beginner: "Débutant",
    },
    projects: {
      title: "Mes Projets",
      subtitle:
        "Projets réalisés à l'école d'ingénieur CESI · Cliquez sur une carte pour en savoir plus",
      view_details: "En savoir plus",
      private_repo: "Dépôt privé",
      private_note: "Dépôt privé (école) · Pas de démo disponible",
      my_contributions: "Mes contributions",
      outcome: "Acquis du projet",
    },
    contact: {
      title: "Contact",
      subtitle: "Parlons de votre projet",
      info_title: "Restons en contact",
      info_text:
        "Je suis actuellement à la recherche d'un stage à l'international, si vous avez des opportunités à proposer n'hésitez pas à me contacter.",
      location: "France",
      availability: "Stage à l'internationnal de juillet 2026 à octobre 2026",
    },
    footer: {
      made_with: "Fait avec",
      rights: "Tous droits réservés.",
    },
  },
  en: {
    nav: {
      home: "Home",
      projects: "Projects",
      contact: "Contact",
    },
    hero: {
      greeting: "Hi, I'm",
      name: "Benjamin REPELLIN",
      role: "Full Stack Developer",
      description:
        "Passionate about IT world and more precisely application development.",
      cta_projects: "View my projects",
      cta_contact: "Contact me",
    },
    about: {
      title: "About me",
      text1:
        "I am currently a computer engineering student at CESI Montpellier, and an apprentice at Atos as an application developer.",
      text2:
        "Passionate about new technologies, I constantly explore new tools to stay up to date with modern development trends.",
      stat1_value: "1.5 years",
      stat1_label: "Of professional experience",
      stat2_value: "10+",
      stat2_label: "Projects completed",
      stat3_value: "6+",
      stat3_label: "Technologies mastered",
    },
    skills: {
      title: "Skills",
      subtitle: "Technologies & tools I master",
      level_expert: "Expert",
      level_advanced: "Advanced",
      level_intermediate: "Intermediate",
      level_beginner: "Beginner",
    },
    projects: {
      title: "My Projects",
      subtitle:
        "Projects completed at CESI engineering school · Click a card to learn more",
      view_details: "Learn more",
      private_repo: "Private repo",
      private_note: "Private repository (school) · No demo available",
      my_contributions: "My contributions",
      outcome: "Key learnings",
    },
    contact: {
      title: "Contact",
      subtitle: "Let's talk about your project",
      info_title: "Let's stay in touch",
      info_text:
        "I'm currently looking for an international internship, if you have any opportunities to offer, feel free to contact me.",
      location: "France",
      availability: "International internship from July 2026 to October 2026",
    },
    footer: {
      made_with: "Made with",
      rights: "All rights reserved.",
    },
  },
};

export default translations;
